import React, { useState } from 'react';
import ModalForm from '../ModalBlock/ModalForm/ModalForm';
import SubscriptionForm from '../Forms/SpecificForms/SubscriptionForm';

const formData = {
  title: ['Подписка на', 'новости'],
  message:
    'Присылаем статьи, материалы по программированию и IT-новости раз в неделю',
  sentContent: {
    title: 'Вы подписаны на новости',
  },
};

function SubscriptionModal() {
  const [isFormSent, setIsFormSent] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <ModalForm {...formData} isSent={isFormSent} isError={isError}>
      <SubscriptionForm setIsSent={setIsFormSent} setIsError={setIsError} />
    </ModalForm>
  );
}

export default SubscriptionModal;
